export enum WeatherIconStoreModelEnum {
  ClearDay = 'CLEAR_DAY',
  ClearNight = 'CLEAR_NIGHT',
  Thunderstorm = 'THUNDERSTORM',
  Rain = 'RAIN',
  Snow = 'SNOW',
  Sleet = 'SLEET',
  Wind = 'WIND',
  Fog = 'FOG',
  Cloudy = 'CLOUDY',
  PartlyCloudyDay = 'PARTLY_CLOUDY_DAY',
  PartlyCloudyNight = 'PARTLY_CLOUDY_NIGHT',
  Hail = 'HAIL',
  None = 'NONE',
}
